import menuList from '@/utils/menuDefine'
import authority from '@/utils/authority'
import { checkHasPermission } from '@/utils/auth-directive'
import store from '@/store'

function getDefaultState () {
  return {
    beginMenu: [],
    runMenu: [],
    waitMenu: [],
    interruptMenu: [],
    machineRepairWaitMenu: [],
    machineRepairRunMenu: [],
    qualityMenu: [],
    carWashMenu: [],
    carWashWaitMenu: [],
    deliveryMenu: [],
    settlementMenu: []
  }
}

const state = getDefaultState()

// 通过工序类型获取菜单
export function selectMenuByWork (work) {
  const isWait = work.status === 'WAIT'

  switch (work.procedureType) {
    case 'BEGIN':
      return state.beginMenu

    case 'QUALITY':
      return state.qualityMenu

    case 'CAR_WASH':
      return isWait ? state.carWashWaitMenu : state.carWashMenu

    case 'DELIVERY':
      return state.deliveryMenu

    case 'SETTLEMENT':
      return state.settlementMenu
  }

  // 剩下的都是可派工的工序
  switch (work.status) {
    case 'RUN':
      return state.runMenu

    case 'INTERRUPT':
      return state.interruptMenu

    case 'MACHINE_REPAIR_WAIT':
      return state.machineRepairWaitMenu

    case 'MACHINE_REPAIR_RUN':
      return state.machineRepairRunMenu

    default: // WAIT
      return state.waitMenu.filter(item => {
        switch (item.command) {
          case authority.WITHDRAW:
            return !work.beenWorked

          case authority.REWORK:
            return !work.firstProcedureAfterConfirm
        }
        return true
      })
  }
}

// 通过工序类型获取移动端菜单
export function selectMobileMenuByWork (work) {
  return selectMenuByWork(work).filter(item => item.mobile)
}

const mutations = {
  RESET (state) {
    Object.assign(state, getDefaultState())
  },
  UPDATE_BY_PERMISSIONS (state, permissions) {
    let hasEdit = false
    // 如果有编辑权限，增加 READ_EDIT 的权限
    if (checkHasPermission(authority.EDIT_WORK)) {
      permissions.push(authority.READ_EDIT)
      hasEdit = true
    }
    let hasAddParts = false
    if (checkHasPermission(authority.ADD_PARTS_IN_WORK)) {
      permissions.push(authority.READ_ADD_PARTS)
      hasAddParts = true
    }
    if (checkHasPermission(authority.START_END_WORK)) {
      permissions.push(authority.START_WORK)
      permissions.push(authority.END_WORK)
    }
    if (checkHasPermission(authority.START_END_WASH)) {
      permissions.push(authority.START_WASH)
      permissions.push(authority.END_WASH)
    }

    for (const menuKey in state) {
      state[menuKey] = menuList[menuKey].filter(menu => {
        // 如果有编辑菜单，那么去除查看菜单
        switch (menuKey) {
          case 'beginMenu':
            if (hasEdit && menu.command === authority.READ_WORK) return false
            break

          case 'runMenu':
          case 'waitMenu':
          case 'interruptMenu':
          case 'machineRepairWaitMenu':
          case 'machineRepairRunMenu':
            if (hasAddParts && menu.command === authority.READ_WORK) return false
            break
        }

        // 抢单没有推进和派工
        if (store.state.user.workshop.dispatchPattern === 'GRAB') {
          switch (menu.command) {
            case authority.PUSH:
            case authority.DISPATCH:
              return false
          }
        }
        // 自动没有终止
        if (store.state.user.workshop.dispatchPattern === 'AUTO') {
          switch (menu.command) {
            case authority.STOP:
              return false
          }
        }

        return checkHasPermission(menu.command)
      })
    }
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
